import {forEach, isArray} from 'lodash';

import {
  isJSONNode,
  JSONNode,
  JSONValue,
  RecordStringUnknown,
} from './filterJSON';

export type UnflattenDelimiter = undefined | '/' | '.' | '-' | '_';

export const unflattenJSON = ({
  node,
  delimiter,
}: {
  node: JSONNode | JSONValue;
  delimiter: UnflattenDelimiter;
}): any => {
  if (node === null || typeof node !== 'object' || delimiter == null) {
    return node;
  }
  if (isArray(node)) {
    return node.map(d =>
      isJSONNode(d) ? unflattenJSON({node: d, delimiter}) : d
    );
  }

  // Regex that splits on the delimiter, unless the delimiter is at the start of the string
  const delimiterRegex = new RegExp(`(?<!^)\\${delimiter}`);

  // TODO: this breaks on ghost autonomy with '_' delim, they have {batch_size: 64, batch_size_val: 10} which doesn't flatten right.
  // bug is related to the type coercion below.
  const result = {};
  forEach(node, (_, key) => {
    const splitKeys = key.split(delimiterRegex);
    splitKeys.reduce<RecordStringUnknown>(function unflattenReduce(
      out,
      splitKey,
      j
    ): RecordStringUnknown {
      // eslint-disable-next-line no-useless-catch
      try {
        return (out[splitKey] ||
          (out[splitKey] = isNaN(Number(splitKeys[j + 1]))
            ? splitKeys.length - 1 === j
              ? node[key]
              : {}
            : [])) as RecordStringUnknown; // TODO: fix this type coercion
      } catch (err) {
        // console.log('=== ERROR in unflatten()', {
        //   splitKey,
        //   j,
        //   splitKeys,
        //   key,
        //   node: node,
        // });
        throw err;
      }
    }, result);
  });
  return result;
};
